
import React, { PropTypes } from 'react';

export class Check extends React.Component {

  static propTypes = {
    colorSchema: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    classes: PropTypes.string
  };

  getFillColor () {
    switch (this.props.colorSchema) {
      case 'primary':
        return '#00587c';
      case 'green-profile':
        return '#53AD99';
      case 'white':
        return '#ffffff';
      default:
        return '#000000';
    }
  }

  render () {
    const fill = this.getFillColor();

    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.width || '20'}
        height={this.props.height || '20'}
        viewBox="0 0 20 20"
        className={this.props.classes}
      >
        <path
          d="M5.5 17.5c-0.128 0-0.256-0.049-0.354-0.146l-5-5c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707
          0l4.646 4.646 13.646-13.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-14 14c-0.098 0.098-0.226
          0.146-0.354 0.146z"
          fill={fill}
        ></path>
      </svg>
    );
  }
}

export default Check;



/** WEBPACK FOOTER **
 ** ./src/components/svg/check.js
 **/